import { useRef, useCallback } from 'react';

// Umbral en px para que un touch horizontal cuente como swipe y no como
// un tap o un scroll vertical accidental (patrón estándar de galerías
// móviles en iOS/Android).
const SWIPE_THRESHOLD_PX = 50;

export default function useSwipeNavigation({ onSwipeLeft, onSwipeRight }) {
    const touchStart = useRef(null);

    const onTouchStart = useCallback((event) => {
        const touch = event.touches[0];
        touchStart.current = { x: touch.clientX, y: touch.clientY };
    }, []);

    const onTouchEnd = useCallback((event) => {
        if (!touchStart.current) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStart.current.x;
        const deltaY = touch.clientY - touchStart.current.y;
        touchStart.current = null;

        if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) onSwipeLeft?.();
        else onSwipeRight?.();
    }, [onSwipeLeft, onSwipeRight]);

    return { onTouchStart, onTouchEnd };
}
